// @flow

import styled, { css } from 'styled-components';

export default styled.div.attrs({
  route: (props : any) => props.route,
})`
  white-space: normal;
  display: inline-block;
  padding: 0;
  font-size: 1.2rem;
  margin-right: .6rem;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  border: .45rem solid transparent;
  vertical-align: top;
  ${(props : any) => (css`
    width: ${props.size}rem; 
    height: ${props.size > 20 ? (props.size * 1.1) : (props.size * 1.3)}rem;
  `)}
  &.activeItem {
    border-radius: 0.938rem;
    & > .itemImageWrapper > .itemTextWrapper {
      display: block;
      background: rgba(0,0,0,.8) !important;
    }
    & > .itemContentWrapper {
      background: #fff;
      .title {
        color: #484848;
      }
    }
    &:hover {
      & > .itemContentWrapper {
        .title {
          color: #fff;
        }
      }
    }
  }
  &:hover {
    
    & > .itemImageWrapper > .itemTextWrapper {
      display: block;
      background: rgba(0,0,0,.8);
    }
    & > .itemContentWrapper  {
      background-color: rgb(255 255 255 / 8%);
    }
  }
  & > .itemImageWrapper {
    line-height: 0;
    position: relative;
    width: 100%;
    margin: 0;
    height: ${(props : any) => (props.size / 2) + 1}rem;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-color: rgba(255,255,255,.4);
    overflow: hidden;
    & > .duration {
      position: absolute;
      width: 5rem;
      height: 1.875rem;
      background: rgb(0 0 0 / 28%);
      text-align: center;
      line-height: 1.875rem;
      font-size: 1.375rem;
      color: #fff;
      left: 0;
      bottom: 1rem;
      font-weight: bold;
    }
    & > .progressBar {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 0.625rem;
      background-color: #303030;
      direction: ltr;
      & > .percent-prograss {
        display: block;
        background-color: #ea1d5d;
        height: 0.625rem;
        top: 0;
      }
    }
  }
  & > .itemContentWrapper {
    /* background-color: #212121; */
    height: 17rem;
    padding: 0 0.625rem;
    .title {
      font-size: ${(props : any) => (props.size > 20 ? 1.5 : 1.2)}rem;
      /* line-height: 4rem; */
      padding: 0.625rem 0;
      margin: 0;
      color: #fff;
    }
    span {
      display: block;
      color: #848484;
      font-size: ${(props : any) => (props.size > 20 ? 1 : 0.9)}rem;
      ${(props : any) => (css`
        ${props.size < 20 && `
          line-height: 1.5rem;
        `}
      `)}
    }
  }
  &.videoItem:first-child {
    margin-right: 0;
  }
  & > .hdIcon {
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    width: 4rem;
    height: auto;
  }
  .info {
    .date {
      margin-left: 1.875rem;
      position: relative;
      &::after {
        content: '-';
        position: absolute;
        top: 50%;
        left: -1.063rem;
        transform: translateY(-50%);
      }
    }
    .date, .visit {
      display: inline-block;
      white-space: nowrap;
      word-break: keep-all;
    }
  }
`;
